import React from 'react';
import '../App.css';
function Header(){
    return(
        <div className="header">
        <div className="container">
          <h1>
            <span>Eat</span> healthy <br />
            Natural Food
          </h1>
          <p>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magnqua.
          </p>
          <button>Explore Meal</button>
        </div>
      </div>
    );
}
export default Header;